/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserRoleDto = {
    Admin: 'ADMIN',
    AdminDevelopment: 'ADMIN_DEVELOPMENT',
    AdminSuccession: 'ADMIN_SUCCESSION',
    AdminCertification: 'ADMIN_CERTIFICATION',
    Hrbp: 'HRBP',
    HrbpHq: 'HRBP_HQ',
    ManagerP1: 'MANAGER_P1',
    ManagerP2: 'MANAGER_P2',
    Employee: 'EMPLOYEE'
} as const;

export type UserRoleDto = typeof UserRoleDto[keyof typeof UserRoleDto];



